import BaseAPI, { newIdempotencyKey } from './BaseAPI';

// What a technician asks an admin to approve, under /shift-requests.
class ShiftRequestsAPI extends BaseAPI {
  constructor() { super('shift-requests'); }

  // GET /shift-requests/pending → { requests, counts, pendingCount }
  // Admin only; the approval queue.
  pending() { return this.get('/pending'); }

  // GET /shift-requests?status=&idStaff=&kind=&start=&end=
  list(params = {}) {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v) q.set(k, v); });
    return this.get(`/?${q.toString()}`);
  }

  mine(idStaff) { return this.list({ idStaff }); }

  // The four tiles. Each returns { ok, request }.
  //
  // One key per submission, for the same reason as clock-in: a key built from
  // the clock would make two different requests of the same kind inside one
  // minute look like a retry, and the second would silently return the first.
  #submit(idStaff, kind, body) {
    return this.post('/', {
      body: { idStaff, kind, ...body, idempotencyKey: newIdempotencyKey(`${kind}:${idStaff}`) },
    });
  }

  requestTimeOff(idStaff, fromDate, toDate, reason) {
    return this.#submit(idStaff, 'time_off', { fromDate, toDate, reason });
  }

  markDayUnavailable(idStaff, fromDate, reason) {
    return this.#submit(idStaff, 'day_unavailable', { fromDate, reason });
  }

  changeHours(idStaff, details, reason) {
    return this.#submit(idStaff, 'hours_change', { details, reason });
  }

  // `proposedClockOutAt` is optional — leaving it out asks to fix the clock-in
  // alone and leaves the clock-out as it is.
  fixClockTime(idStaff, idShift, { proposedClockInAt, proposedClockOutAt, reason } = {}) {
    return this.#submit(idStaff, 'clock_fix', { idShift, proposedClockInAt, proposedClockOutAt, reason });
  }

  // Admin only. Approving a clock fix applies the correction.
  approve(idRequest, decisionNote) {
    return this.post(`/${idRequest}/approve`, { body: { decisionNote } });
  }

  decline(idRequest, decisionNote) {
    return this.post(`/${idRequest}/decline`, { body: { decisionNote } });
  }

  withdraw(idRequest, idStaff) {
    return this.post(`/${idRequest}/withdraw`, { body: { idStaff } });
  }
}

export const ShiftRequestsService = new ShiftRequestsAPI();
export default ShiftRequestsAPI;
